// extracted by mini-css-extract-plugin
module.exports = {"modal":"EmailMfaOtpModal_modal__37-vN"};